import { SortingState } from '@tanstack/react-table'
import request from './request'
import { isEmpty } from 'lodash'
import { useBuildSortingParams } from '../lib/hooks/useBuildSortingParams'

export const downloadCSV = async function ({
  url,
  fetchOptions,
  headers,
  fileName,
  sortOrder,
}: {
  url: string
  fetchOptions: Record<string, unknown>
  headers: Array<{ header: unknown; accessorKey: string }>
  fileName: string
  sortOrder?: SortingState
}): Promise<void> {
  try {
    const sorting = sortOrder
      ?.map((sort) => `${sort.id}:${sort.desc ? 'desc' : 'asc'}`)
      .join(';')

    const queryParams = Object.entries(fetchOptions).reduce(
      (acc: Record<string, unknown>, [key, value]) => {
        if (typeof value === 'number') {
          acc[key] = value
        } else if (!isEmpty(value)) {
          if (typeof value === 'object') {
            if (Array.isArray(value)) acc[key] = value.map(({ value }) => value)
            else if (value !== null && Object.hasOwn(value, 'value'))
              acc[key] = (value as Record<string, unknown>).value
          } else {
            acc[key] = value
          }
        }
        return acc
      },
      {},
    )
    const res = await request<{ data: Array<Record<string, unknown>> }>({
      url: url,
      params: { ...queryParams, pageIndex: 1, pageSize: 10000, sorting },
    })
    const csvContent = headers.map((header) => header.header).join(',') + '\n'
    const csvRows = res.data
      .map((row) => {
        return headers
          .map((header) => {
            if (!header.accessorKey) return ''
            const value = row[header.accessorKey]
            if (value === null || value === undefined) return ''
            return `"${value}"`
          })
          .join(',')
      })
      .join('\n')

    const fileData = new Blob([csvContent + csvRows], {
      type: 'text/csvcharset=utf-8',
    })
    const temp_link = document.createElement('a')
    temp_link.download = fileName
    temp_link.href = URL.createObjectURL(fileData)
    document.body.appendChild(temp_link)
    temp_link.click()
    document.body.removeChild(temp_link)
  } catch (err) {
    return Promise.reject(err)
  }
}

export default downloadCSV
